import { render, staticRenderFns } from "./ChangeDashboardColumns.vue?vue&type=template&id=2bb6273d"
import script from "./ChangeDashboardColumns.vue?vue&type=script&lang=js"
export * from "./ChangeDashboardColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports